<template>
  <div class="home">
    <div>
      <div class="loginBox">
        <!-- 表情图部分 -->
        <img :src="loginSrc" alt="表情图" class="loginImages" />
        <!-- 登录框部分 -->
        <el-card class="box_rgb">
          <div class="login_title"> XR资源管理平台</div>
          <el-form label-width="90px" :model="from" :rules="rules" ref="ruleForm" class="login_input">
            <!-- 账号部分 -->
            <el-form-item label="用户名" prop="username" class="login-text">
              <el-input v-model.trim="from.username" @focus="changeImages(2)" @blur="recoverImages"></el-input>
            </el-form-item>
            <!-- 密码部分 -->
            <el-form-item label="密码" prop="password" class="login-text">
              <el-input v-model.trim="from.password" type="password" show-password style="margin-top: 5px"
                @focus="changeImages(3)" @blur="recoverImages"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="passwords" class="login-text">
              <el-input v-model.trim="from.passwords" type="password" show-password style="margin-top: 5px"
                @focus="changeImages(3)" @blur="recoverImages"></el-input>
            </el-form-item>
            <!-- 验证码 -->
            <!-- <div class="form-group" style="display: flex;">
                    <div>
                    <span style="color: white;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;验证码</span>&nbsp;&nbsp;
                        <input type="text" id="code" v-model="code" class="code"  placeholder="请输入您的验证码" />
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;
                   <div class="login-code" @click="refreshCode">
            
             <yanzheng :identifyCode="identifyCode"></yanzheng>
            </div>
                 </div> -->
            <!-- 登录按钮 -->
            <el-form-item>
              <el-button type="primary" style="width: 100%; margin-top: 10px; height: 40px" @click="login">注册</el-button>
            </el-form-item>
          </el-form>
          <!-- 手机号登录 -->
          <div class="denglu">
            <!-- <el-link type="info" style="color: white;">手机号登录</el-link> -->
            <router-link to="/login" style="color: white;">已有账号，去登录</router-link>
            <el-link type="info" style="color: white;">忘记密码</el-link>
          </div>

        </el-card>
      </div>
    </div>
    <!-- 星空效果部分 -->
    <div class="two">
      <div class="three" v-for="(item, index) in items" :key="index" ref="three"></div>
    </div>
  </div>
</template>

<script>

// import yanzheng  from './yanzhengma.vue'
import { Logins, getUserId } from "@/api/index.js"
import { Message } from 'element-ui';
export default {
  name: "SignIn",
  // components: { yanzheng },
  data() {
    //验证账号正则
    var validatePass = (rule, value, callback) => {
      //三个参数：规则，值，回调
      //创建个正则用于判断
      const reg = /^/;
      //判断：账号验证是否通过
      if (reg.test(value)) {
        //放行
        callback();
      } else {
        //提示错误信息
        callback(new Error("用户名不能为空"));
      }
    };
    return {
      //星空效果div循环生成800个
      items: 800,
      distance: 800,
      //双向绑定
      from: {
        username: "",
        password: "",
        passwords: "",
      },
      //首页三个表情图切换
      loginSrc: require("@/assets/login/tu3.jpg"),
      //验证条件
      rules: {
        //账号部分
        username: [
          //验证方法用validatePass,通过blur（失去焦点）事件判断验证，
          { validator: validatePass, trigger: "blur" },
          //required：true代表必填，message：提示信息，trigger：根据什么事件判断，同上
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        //密码部分
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        passwords: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
        ],
      },
      identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",//随机生成的验证码
      code: "",//text框输入的验证码
    };
  },
  created() {
    //页面加载完全局监听键盘事件，然后调用函数
    document.addEventListener("keyup", this.watchEnter);
    this.refreshCode()
  },
  destroyed() {
    //页面跳转销毁全局监听事件
    document.removeEventListener("keyup", this.watchEnter);
  },
  mounted() {
    //星空效果
    //获取dom 800个div
    const starArr = this.$refs.three;
    //循环div
    starArr.forEach((item) => {
      //随机数
      const speed = 0.2 + Math.random() * 1;
      const thisDistance = this.distance + Math.random() * 360;
      //每一项的样式
      item.style.transformOrigin = `0 0 ${thisDistance}px`;
      item.style.transform = `translate3d(0, 0, -${thisDistance}px) rotateY(${Math.random() * 360
        }deg) rotateX(${Math.random() * -50}deg) scale(${speed})`;
    });
    // 验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    //登录验证
    login() {
      //验证通过发请求
      if (this.code != this.identifyCode) {
        Message('请输入正确的验证码')
        this.refreshCode()
      } else {
        Logins({
          username: this.from.username,
          password: this.from.password
        }).then((res) => {
          localStorage.setItem('token', res.data.token);
          Message({
            message: '登录成功',
            type: 'success'
          });
          this.GetId()
        }).catch(() => {
        })

      }

    },
    //获取角色id
    GetId() {
      getUserId()
    },
    //判断按键
    watchEnter(e) {
      //按键判断：e.which返回当前按键的键值，然后if判断键值是否等于13,13是回车键的键值。如果是调用登录方法发请求
      let keyNum = e.which;
      if (keyNum == 13) {
        this.login();
      }
    },
    //获取焦点时改变图片路径
    changeImages(index) {
      if (index == 2) {
        this.loginSrc = require("@/assets/login/tu2.jpg");
      }
      if (index == 3) {
        this.loginSrc = require("@/assets/login/tu1.jpg");
      }
    },
    //失去焦点时恢复第一章图片
    recoverImages() {
      this.loginSrc = require("@/assets/login/tu3.jpg");
    },

  },
};
</script>


<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

/* input登录 */
.login_input {
  margin-left: 40px;
  margin-top: 100px;
  width: 370px;
}

/* 背景色透明 */
.box_rgb {
  height: 430px;
  width: 550px;
  border-radius: 30px;
  background-image: linear-gradient(#263238, #2d94a7);
  transform: translateX(50%);
  margin-top: -200px;
  box-shadow: 0px 0px 15px 5px #c4fcf0;
}

// login页表情图
.loginImages {
  position: absolute;
  top: -315px;
  left: 84%;
  width: 180px;
  z-index: 2;
}

.loginBox {
  position: absolute;
  right: 50%;
  top: 50%;
}

/* 标题 */
.login_title {
  width: 350px;
  text-align: center;
  position: absolute;
  right: 50%;
  top: 40px;
  transform: translateX(50%);
  font-size: 34px;
  font-weight: bold;
  color: #fff6ff;
}

//星空效果样式部分
.home {
  position: relative;
  width: 100%;
  height: 98.2vh;
  //星空图的背景渐变色
  background: radial-gradient(260% 67% at bottom center,
      #32cbc6 10%,
      #63baaa 40%,
      #00838f 65%,
      #263238 130%);

  overflow: hidden;
}

.two {
  position: absolute;
  left: 50%;
  transform-style: preserve-3d;
  transition: perspective(500deg);
  perspective-origin: 50% 100%;
  -webkit-perspective-origin: 50% 100%;
  -moz-perspective-origin: 50% 100%;
  animation: xinkon 90s linear infinite;
  bottom: -100px;

  .three {
    width: 2px;
    height: 2px;
    background: #fff9c4;
    position: absolute;
    top: 0;
    left: 0;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
  }
}

@keyframes xinkon {
  0% {
    transform: perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(0);
  }

  100% {
    transform: perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(-360deg);
  }
}
</style>
<style>
.login-text .el-form-item__label {
  color: #fff;
  font-size: 16px;
}


.login-title {
  font-size: 20px;
}

.box-card {
  width: 375px;
}

.code {
  width: 124px;
  height: 31px;
  border: 1px solid rgba(186, 186, 186, 1);
}

.login-code {
  cursor: pointer;
}

.denglu {
  display: flex;
  justify-content: space-around;
}

a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
</style>
